import React from 'react';

const PdfIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="133.667" height="45">
    <path d="M66.833 45A71.372 71.372 0 0 1 26.28 32.416 73.716 73.716 0 0 1 0 0h133.667a73.712 73.712 0 0 1-26.281 32.417A71.373 71.373 0 0 1 66.833 45z" />
  </svg>
);

export default PdfIcon;
